import { type } from 'arktype';

import { CountryType } from '@/types/country';

export enum NewContactType {
  internal = 'internal',
  external = 'external',
  unset = 'unset',
}

export const addContactFlowModalSchema = type({
  contactType: type.valueOf(NewContactType),
  country: type
    .valueOf(CountryType)
    .filter((c: CountryType): boolean => c !== CountryType.unset)
    .configure({ message: 'VALIDATION_REQUIRED' })
    .as<CountryType>(),
  paymentMethod: type('string > 0').configure({ message: 'VALIDATION_REQUIRED' }),
});
